import {
  GOOGLE_FONT_FAMILIES,
  LOCAL_FONT_FACES,
  LOCAL_FONT_FAMILIES,
} from "./fonts";

let designerFontsLoaded = false;
const singleLoaded = new Set();

const chunk = (arr, size) => {
  const out = [];
  for (let i = 0; i < arr.length; i += size) {
    out.push(arr.slice(i, i + size));
  }
  return out;
};

const injectLink = (id, href) => {
  if (typeof document === "undefined") return;
  if (document.getElementById(id)) return;
  const link = document.createElement("link");
  link.id = id;
  link.rel = "stylesheet";
  link.href = href;
  document.head.appendChild(link);
};

const injectStyle = (id, css) => {
  if (typeof document === "undefined") return;
  if (document.getElementById(id)) return;
  const style = document.createElement("style");
  style.id = id;
  style.textContent = css;
  document.head.appendChild(style);
};

const fontUrl = (file) => {
  const base = process.env.PUBLIC_URL || "";
  return `${base}/fonts/${file}`;
};

const fontFaceCss = (font) => `
@font-face {
  font-family: "${font.family}";
  src: url("${fontUrl(font.file)}") format("truetype");
  font-weight: ${font.weight};
  font-style: normal;
  font-display: swap;
}`;

const ensureLocalFontsLoaded = () => {
  injectStyle(
    "designer-local-fonts",
    LOCAL_FONT_FACES.map(fontFaceCss).join("\n"),
  );
};

// Loads every designer Google Font once, split across a few requests so no
// single URL gets too long. Uses the tolerant v1 API which ignores weights a
// family doesn't have (script fonts fall back to 400 without erroring).
export function ensureDesignerFontsLoaded() {
  if (designerFontsLoaded || typeof document === "undefined") return;
  designerFontsLoaded = true;
  ensureLocalFontsLoaded();

  chunk(GOOGLE_FONT_FAMILIES, 18).forEach((group, idx) => {
    const families = group
      .map((f) => `${f.replace(/ /g, "+")}:400,500,600,700`)
      .join("|");
    injectLink(
      `designer-google-fonts-${idx}`,
      `https://fonts.googleapis.com/css?family=${families}&display=swap`,
    );
  });
}

// Loads a single family on demand (e.g. a saved design uses a font not in the
// curated list).
export function ensureFontLoaded(family) {
  if (!family || typeof document === "undefined") return;
  if (LOCAL_FONT_FAMILIES.includes(family)) {
    ensureLocalFontsLoaded();
    return;
  }
  if (singleLoaded.has(family)) return;
  singleLoaded.add(family);
  injectLink(
    `google-font-${family.replace(/\s+/g, "-").toLowerCase()}`,
    `https://fonts.googleapis.com/css?family=${family.replace(/ /g, "+")}:400,500,600,700&display=swap`,
  );
}
